import { ENDPOINTS } from '../utils/endpoints'
import { getAPIwithToken } from '../utils/fetchApi'

export interface CategoryItem {
  id: number
  name: string
  isActive?: boolean
  is_active?: number | boolean
  status?: number
  createdAt?: string
  created_at?: string
  created?: string
  updatedAt?: string
  updated_at?: string
  modified?: string
  erp_id?: string | null
  erpId?: string | null
  hsnCode?: string | null
  hsn_code?: string | null
  seq?: number
  category_seq?: number
  image?: string | null
  size?: string
  is_special?: boolean
  isSpecial?: boolean
}

export interface CategorySummary {
  total_count: number
  active_count: number
  inactive_count: number
}

export interface CategoryPagination {
  total_records: number
  page: number
  limit: number
  total_pages: number
  showing_from: number
  showing_to: number
}

export interface GetCategoriesData {
  summary?: CategorySummary
  categories?: CategoryItem[]
  data?: CategoryItem[]
  pagination?: CategoryPagination
}

export interface GetCategoriesResponse {
  success: boolean
  statusCode: number
  message: string
  data: GetCategoriesData | CategoryItem[]
}

export interface FetchCategoriesParams {
  page?: number
  limit?: number
  search?: string
  status?: string
}

export async function getCategories(params?: FetchCategoriesParams): Promise<GetCategoriesResponse> {
  let endpoint = ENDPOINTS.GET_CATEGORIES

  if (params) {
    const query = new URLSearchParams()
    if (params.page) {
      query.append('page', params.page.toString())
    }
    if (params.limit) {
      query.append('limit', params.limit.toString())
    }
    if (params.search) {
      query.append('search', params.search)
    }
    if (params.status && params.status !== 'All') {
      query.append('status', params.status.toLowerCase())
    }
    const queryString = query.toString()
    if (queryString) {
      endpoint += `?${queryString}`
    }
  }

  return getAPIwithToken<GetCategoriesResponse>(endpoint)
}
